<ng-container [formGroup]="form">
  <textarea
    [attr.data-qa-id]="question.label || question.placeholder"
    [formControlName]="question.id"
    [id]="question.id"
    [placeholder]="question.placeholder"
    class="input details-text-area"
  ></textarea>
</ng-container>
